import React from 'react';
import { MapPin, Phone, Mail, Instagram, Linkedin, Facebook, ArrowUpRight } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="luxury-footer">
      {/* Background Watermark for Premium Feel */}
      <div className="footer-watermark">PG</div>

      <div className="container">
        
        <div className="footer-top-grid">
          
          {/* --- Col 1: Brand Identity --- */}
          <div className="footer-brand">
            <h2 className="brand-logo" style={{marginLeft:'0px'}}>Property Galleria LLP</h2>
            <p className="brand-tagline">Realty Simplified. Trust Amplified.</p>
            <div className="brand-contact">
              <a href="tel:+916309824545" className="contact-link">
                <Phone size={18} /> 6309824545
              </a>
              {/* <a href="mailto:info@propertygalleria.com" className="contact-link">
                <Mail size={18} /> info@propertygalleria.com
              </a> */}
            </div>
          </div>

          {/* --- Col 2: Quick Navigation --- */}
          <div className="footer-nav">
            <h4 className="footer-header">Quick Links</h4>
            <ul className="nav-list">
              <li><a href="/">Home <ArrowUpRight size={14} className="arrow" /></a></li>
              <li><a href="/about">About Us <ArrowUpRight size={14} className="arrow" /></a></li>
              <li><a href="#services">Services <ArrowUpRight size={14} className="arrow" /></a></li>
              <li><a href="#properties">Properties <ArrowUpRight size={14} className="arrow" /></a></li>
              <li><a href="#contact">Contact <ArrowUpRight size={14} className="arrow" /></a></li>
            </ul>
          </div>

{/* --- Col 3: Head Office --- */}
<div className="footer-address">
  <h4 className="footer-header">Head Office</h4>
  <p className="address-text">
    H No: 2-1-1/HL/121/3,<br/>
    Plot No 121, Nayaka Anuradha Nilayam,<br/>
    Uppal Bagayath Phase II,<br/>
    Hyderabad, Telangana.
  </p>
  <a
    href="https://www.google.com/maps/search/?api=1&query=H+No:+2-1-1/HL/121/3,+Plot+No+121,+Nayaka+Anuradha+Nilayam,+Uppal+Bagayath+Phase+II,+Hyderabad,+Telangana"
    target="_blank"
    rel="noopener noreferrer"
    className="map-link"
  >
    <MapPin size={16} /> <span>View on Map</span>
  </a>
</div>


          {/* --- Col 4: Registered Office --- */}
          <div className="footer-address">
            <h4 className="footer-header">Registered Office</h4>
            <p className="address-text">
              3-50, J-104/204,<br/>
              Hi Vision Residency,<br/>
              Kompally, Hyderabad,<br/>
              Telangana 500100.
            </p>
            <div className="map-link">
              <MapPin size={16} /> <span>View on Map</span>
            </div>
          </div>

        </div>

        {/* --- Footer Bottom Bar --- */}
        <div className="footer-bottom-bar">
          <div className="copyright">
            &copy; {currentYear} Property Galleria LLP. All rights reserved.
          </div>
          
          <div className="social-row">
            <a href="#" className="s-icon" aria-label="Instagram"><Instagram size={20} /></a>
            <a href="#" className="s-icon" aria-label="LinkedIn"><Linkedin size={20} /></a>
            <a href="#" className="s-icon" aria-label="Facebook"><Facebook size={20} /></a>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;